import './ResultSummary.css';

interface IResultSummaryProps {
  text: string;
}

export default function ResultSummary({ text }: IResultSummaryProps) {
  return <p className="result-summary">{text}</p>;
}
